module.exports = __webpack_public_path__ + "static/media/tj.bf8b6f1c.webp";